import {
  FIND_SINGLE_ENCRYPT_PSEUDONYMS_REQUEST,
  findSingleEncryptPseudonymsSuccess,
  findSingleEncryptPseudonymsFailure
}                   from 'Redux/Action';
import { ofType }   from 'redux-observable';
import { from }     from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findSingleEncryptPseudonymsEpic(action$, store$, { EncryptSinglePseudonymRepository }) {
  return action$.pipe(
    ofType(FIND_SINGLE_ENCRYPT_PSEUDONYMS_REQUEST),
    mergeMap(action => from(
      EncryptSinglePseudonymRepository.findAll(action.payload)
        .then(({ encryptPseudonyms, meta }) => findSingleEncryptPseudonymsSuccess({
          encryptPseudonyms,
          response: meta,
          request: action
        }))
        .catch(error => findSingleEncryptPseudonymsFailure({ error, request: action })),
    )),
  );
}
